import type { PropsWithChildren } from 'react';
import type React from 'react';

import { usePreloadRoutes } from '../hooks/preloadRoutes';

type PreloadProps = Readonly<{
	preload?: readonly string[];
}>;

export const Preload: React.FC<PropsWithChildren<PreloadProps>> = ({ preload, children }) => {
	usePreloadRoutes(preload);

	return <>{children}</>;
};
